export default __webpack_public_path__ + "static/media/bb.ed6fdae5.svg";